
import * as React from 'react';
import { Card, Icon } from '@/components/site/ui';
import { cn } from '@/lib/utils';

export function EmptyState({
  icon,
  title,
  children,
  action,
  surface = 'card',
  tone = 'neutral',
  size = 'default',
  className,
}: {
  icon?: string;
  title?: React.ReactNode;
  children?: React.ReactNode;
  action?: React.ReactNode;
  surface?: 'card' | 'plain' | 'dashed';
  tone?: 'neutral' | 'destructive' | 'highlight';
  size?: 'compact' | 'default';
  className?: string;
}) {
  const content = (
    <>
      {icon && (
        <span
          className={cn(
            'flex h-12 w-12 items-center justify-center rounded-full',
            tone === 'destructive' && 'bg-destructive-soft text-destructive-soft-foreground',
            tone === 'highlight' && 'bg-highlight-subtle text-highlight-strong',
            tone === 'neutral' && 'bg-muted text-muted-foreground',
          )}
        >
          <Icon name={icon} size={22} />
        </span>
      )}
      {title && <p className="text-sm font-medium text-foreground">{title}</p>}
      {children && <div className="max-w-sm text-[0.8125rem] text-muted-foreground">{children}</div>}
      {action && <div className="mt-1">{action}</div>}
    </>
  );

  const classes = cn(
    'flex flex-col items-center gap-2 text-center',
    size === 'default' ? 'px-6 py-12' : 'px-5 py-8',
    surface === 'dashed' && 'border-dashed shadow-none',
    className,
  );

  if (surface === 'plain') return <div className={classes}>{content}</div>;
  return <Card className={classes}>{content}</Card>;
}
